
export const SET_SLOT_DATA = (state, payload) => {
  const avail_person = payload.filter(item => {
    return !item.getKado
  }).map(person => person)


  const avail_kado = payload.filter(item => {
    return !item.gifted
  }).map(person => person.noKado)
  
  state.list_kado = avail_kado
  state.slots = avail_person
  state.person = avail_person
  // console.log(state, "<< data kado fiiinal")
} 

export const SET_LOADING = (state, status) => {
  state.isLoading = status
}

export const UPDATE_SLOT_DATA = (state, payload) => {
  let updated = payload.reduce((acc, curr) => {
    const stored = state.slots.find((el) => el.digit == curr.digit)
    if (stored){
      stored.no_get_kado = curr.get_kado;
      console.log(stored, curr.get_kado, "< proses 1")
      acc.push(stored);
    } else {
      acc.push(curr);
    }
    return acc;
  }, [])
  console.log(updated, "<< updated slots")
}